import { Language } from '../../lang/Language'

export class CannotPlayActionError extends Error {
  constructor(action: string, state: string) {
    super(Language.strings.error.board.cannotPlayAction(action, state))
  }
}
